import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import { mentorLoginApi } from "../../apis/authentication";


export const mentorLogin = createAsyncThunk(
    "mentor/login",
    async ({ email, password }) => {
      const response = await mentorLoginApi({ email, password });
      return response.data;
    }
  );
  
  


const authenticationSlice = createSlice({
  name: "mentorAuthentications",
  initialState: {
   mentorAuthentications : [],
    status: "idle",
    error: null,
  },
  reducers: {
    reset: (state) => {
      state.mentorAuthentications = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(mentorLogin.pending, (state) => {
        state.status = "loading";
      })
      .addCase(mentorLogin.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.mentorAuthentications = action.payload;
      })
      .addCase(mentorLogin.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});



export default authenticationSlice.reducer;
